import { Textarea } from '@art-of-hospitality-solutions-llc/ui-kit/components/textarea';

import FieldShell from './FieldShell';

interface TextareaFieldProps {
  title?: string;
  description?: string;
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;
}

export default function TextareaField({
  title,
  description,
  placeholder,
  value,
  onChange,
}: TextareaFieldProps) {
  return (
    <FieldShell title={title} description={description}>
      <Textarea
        value={value ?? ''}
        placeholder={placeholder}
        rows={4}
        onChange={(e) => onChange(e.target.value)}
      />
    </FieldShell>
  );
}
